import styled from 'styled-components'

import DeclarationForm from '../../components/forms/DeclarationForm'
import CAcceptTerms from '../../components/forms/DeclarationForm/AcceptTerms'

import CHome from './Home'

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
`

export const AcceptTerms = styled(CAcceptTerms)``

export const Home = styled(CHome)``

export const Form = styled(DeclarationForm)``
